export default __webpack_public_path__ + "2e286fec5722cd85bc321edffb9a3a31.png";